<template>

  <div class="p-fluid report-field">
    <div :class="['p-grid report-field-header', {'report-field-header-small':section==='REPORT'}]">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label>{{$t('report.'+section+'.'+guide.key)}}</label>
      </div>
    </div>
    <div v-tooltip.top="{ value: tooltipDisabled, disabled: !dropdownDisabled }">

      <div v-if="((isSerial || isModel) && reportId && !overview)" class="p-pt-2 p-pb-2">
        {{ overviewText }}
      </div>

      <Dropdown v-else-if="!overview" v-model="item" :options="domains[guide.domain]" optionLabel="name" optionValue="code" :filter="isSpecial"
              :placeholder="$t('report.'+section+'.'+guide.key+'_ph')" 
              :disabled="dropdownDisabled || guide.disabled"
              @change="dataChanged"  
              :class="{'p-invalid':guide.invalid}" />

      <span v-else>{{ overviewText }}</span>
      
    </div>
  </div>

</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      reportId: String,
      section: String,
      guide: Object,
      data: Object,
      domains: Object,
      overview: Boolean,
      overwriteData: [String, Number, Object],
    },
  data() {
    return {
      item: null,
    }
  },
  computed: {
    isSpecial: function() {
      return this.guide.domain && (this.guide.domain === "countries" || this.guide.domain === "models" || this.guide.domain === "serialNumbers");
    },
    isSerial: function() {
      return this.guide.domain && this.guide.domain === "serialNumbers";
    },
    isModel: function() {
      return this.guide.domain && this.guide.domain === "models";
    },
    dropdownDisabled: function() {
      return !this.overview && this.isSerial && (this.domains[this.guide.domain]==null || this.domains[this.guide.domain].length==0);
    },
    tooltipDisabled: function() {
      return this.dropdownDisabled ? this.$t('report.'+this.section+'.'+this.guide.key+'_disabledtooltip') : '';
    },
    overviewText: function() {
      // console.log(this.item)
      // console.log(JSON.stringify(this.domains[this.guide.domain]))
      if(this.isSpecial) {
        if(this.item && this.guide.domain && this.guide.domain === "models" && this.domains && this.domains[this.guide.domain]) {
          for(let i=0; i<this.domains[this.guide.domain].length; i++) {
            if(this.domains[this.guide.domain][i].code==this.item) {
              return this.domains[this.guide.domain][i].name;
            }
          }
          return this.item ?? '-';
        } else {
          return this.item ?? '-';
        }
      }
       else {
        return this.data[this.guide.key] ? this.data[this.guide.key].value : '-';
      }
    }
  },
  created() {
    if(this.isSpecial) {
      this.item = this.data[this.guide.key];
    } else {
      this.item = this.data[this.guide.key] ? this.data[this.guide.key].code : null
    }
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
    'overwriteData': {
      deep: true,
      handler() {
        if(this.isSpecial) {
          if(this.overwriteData && this.overwriteData != this.data[this.guide.key]) {
            // console.log("Overwrite data is DIFFERENT from original data:", this.overwriteData);
            this.item = this.overwriteData ?? this.data[this.guide.key];
            this.dataChanged({ value: this.item });
          // } else {
          //   console.log("Overwrite data is EQUAL to original data:", this.overwriteData);
          }
        } else {
          this.item = this.data[this.guide.key] ? this.data[this.guide.key].code : null
          this.dataChanged({ value: this.item });
        }
      }
    }
    // data: {
    //   deep: true,
    //   handler() {
    //     if(this.isSpecial) {
    //       this.item = this.data[this.guide.key];
    //     } else {
    //       this.item = this.data[this.guide.key] ? this.data[this.guide.key].code : null
    //     }
    //   }
    // }
  },
  methods: {
    dataChanged(ev) {
      if(this.isSpecial) {
        this.$emit("update:data", { key: this.guide.key, value: ev.value });
      } else {
        let items = this.domains[this.guide.domain];
        for(let i=0; i<items.length; i++) {
          if(items[i].code == ev.value) {
            this.$emit("update:data", { 
              key: this.guide.key, 
              value: {
                code: items[i].code,
                value: items[i].name
              }
            });
            break;
          }
        }
      }
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        this.item = null;
      }
    }
    
  }
}
</script>

<style scoped>

</style>